export const uiBlock = {
    name: 'UI Block',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        children: {
            name: 'Children',
            type: 'Array',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [],
            items: {
                type: 'Link',
                validations: [
                    {
                        linkContentType: [
                            'uiButton',
                            'uiDownloadButton',
                            'uiEmailSignup',
                            'uiImage',
                            'uiLoginContainer',
                            'uiMarkdown',
                            'uiTextBlock',
                            'uiTrelloBoard',
                            'uiVideo',
                            'uiVideoPlayer',
                            'uiWebinarLink',
                            'uiHelpScoutSearch'
                        ]
                    }
                ],
                linkType: 'Entry'
            }
        },
        fullHeight: {
            name: 'Full Height',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        shadow: {
            name: 'Shadow',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        roundedCorners: {
            name: 'Rounded Corners',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['Small', 'Medium', 'Large'] }]
        },
        orientation: {
            name: 'Orientation',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['vertical', 'horizontal'] }]
        },
        spacing: {
            name: 'Spacing',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [
                { in: ['tight', 'compact', 'cozy', 'comfortable', 'outerspace'] }
            ]
        },
        verticalAlign: {
            name: 'Vertical Align',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['Top', 'Middle', 'Bottom'] }]
        },
        appearance: {
            name: 'Appearance',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['No Padding', 'Top Blue Stripe', 'Neutral Border'] }]
        },
        background: {
            name: 'Background',
            type: 'Object',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiBlock.js.map